module.exports = __webpack_public_path__ + "static/media/mingxingBuss.239b82f4.svg";